import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const ValuesSection = () => {
  const { language } = useLanguage();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const values = [
    { title: 'STRUCTURE' },
    { title: 'EXIGENCE' },
    { title: 'COHÉRENCE' },
    { title: 'VISION' },
    { title: 'IMPACT' },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };

  return (
    <section
      id="values"
      ref={ref}
      className="py-24 md:py-32 bg-white"
      data-testid="values-section"
    >
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-16 md:mb-20">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            className="inline-block text-xs font-semibold tracking-[0.3em] uppercase text-neutral-500 mb-4"
          >
            {language === 'fr' ? 'Ce qui nous définit' : 'What defines us'}
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.1 }}
            className="heading-xl text-4xl md:text-5xl lg:text-6xl text-black"
            data-testid="values-title"
          >
            {language === 'fr' ? 'Nos valeurs' : 'Our values'}
          </motion.h2>
        </div>

        {/* Values List - Clean minimal style */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          className="max-w-2xl mx-auto"
        >
          {values.map((value, index) => {
            const isLast = index === values.length - 1;
            
            return (
              <motion.div
                key={index}
                variants={itemVariants}
                className={`py-8 md:py-10 ${!isLast ? 'border-b border-neutral-200' : ''}`}
                data-testid={`value-card-${index}`}
              >
                <motion.h3
                  className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-black text-center tracking-wide"
                  whileHover={{ scale: 1.02, letterSpacing: '0.1em' }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  {value.title}
                </motion.h3>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default ValuesSection;
